import { render, staticRenderFns } from "./RecaptchaDisclaimer.vue?vue&type=template&id=955f5fa2&scoped=true&functional=true"
var script = {}
import style0 from "./RecaptchaDisclaimer.vue?vue&type=style&index=0&id=955f5fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "955f5fa2",
  null
  
)

export default component.exports